import "./index.css";
import { useState, useEffect } from "react";
import { Select, notification } from "antd";
import { useAuth } from "../../context/auth";

const PageDropdown = ({ type, update, ...props }) => {
  const { accessToken } = useAuth();

  const [pages, setPages] = useState([]);
  useEffect(() => {
    async function getPages() {
      const url = new URL('/api/page', window.location);
      if (type) url.searchParams.append('type', type);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { pages } = await res.json();
        setPages(pages);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    getPages();
  }, [accessToken, type, update]);

  return (
    <Select
      {...props}
      showSearch
      placeholder="Title"
      optionFilterProp="children"
    >
      {pages.map(page => (
        <Select.Option key={page.id} value={page.id}>
          {page.titleEn} - {page.titleTh}
        </Select.Option>
      ))}
    </Select>
  );
};

export default PageDropdown;
